import { BetPickRaceDayFolderFragment, BetPickRaceFolderFragment } from '@graphqlTypes/sitecore';
import { DeepReadonly } from '@src/utils/type-utils';
import { makeAutoObservable } from 'mobx';
import { BetPickDetail, KolStore } from './kol-store';

export class RaceBetPickStore {
    raceDayKey = '';
    raceKey = '';

    constructor(private kolStore: KolStore) {
        makeAutoObservable(this, undefined, { deep: false });
    }

    get raceDay(): DeepReadonly<BetPickRaceDayFolderFragment> | undefined {
        const raceDay = this.kolStore.data?.kolData.betPickItem?.raceDays.find((raceDay) => {
            if (raceDay.name === this.raceDayKey) {
                return true;
            }
        });
        return raceDay;
    }

    get race(): DeepReadonly<BetPickRaceFolderFragment> | undefined {
        const race = this.raceDay?.races.find((race) => race.name === this.raceKey);
        return race;
    }

    get betpicks(): DeepReadonly<BetPickDetail[]> | undefined {
        if (this.raceDayKey && this.raceKey) {
            return this.kolStore.allBetPicks?.filter(
                (bp) =>
                    bp.race?.name === this.raceKey &&
                    bp.raceDay?.name === this.raceDayKey &&
                    bp.betpick.enabled?.boolValue
            );
        }
    }
}
